module.exports = __webpack_public_path__ + "static/house-2-c7678879d3492acfac04e12498c83269.png";